export default __webpack_public_path__ + "static/media/eed7daf4b748a396.817cd0b7476fe7f70921f074eff9a338.svg";